import IconButton from "./index.jsx";

export default IconButton;
